import type { ReactElement } from 'react';
import { GuestQuoteSupport } from './guest-quote-support';

/** 찾을 수 없음(결정 G9) — 서명 불일치·없는 견적·주소 형식 오류를 하나로 보여 준다(견적이 있는지 알려 주지 않는다). */
export const GuestQuoteNotFound = (): ReactElement => (
  <div className="flex flex-col gap-12">
    <section className="flex flex-col items-center gap-3 border-y border-foreground/10 py-24 text-center">
      <h1 className="text-2xl font-bold tracking-[-0.02em] sm:text-3xl">견적을 찾을 수 없어요</h1>
      <p className="text-sm text-muted-foreground">
        링크 주소가 잘못됐거나 더 이상 열 수 없는 견적이에요. 받은 링크를 다시 확인하거나 고객센터로
        문의해 주세요.
      </p>
    </section>
    <GuestQuoteSupport />
  </div>
);
